// extracted by mini-css-extract-plugin
export default {"stepCounter":"stepCounter__2fhHB","dot":"dot__2x2Ch","active":"active__2Yj8L","dotsBox":"dotsBox__3P2Qv"};